<div class="add-lookup-container">
    <div class="lookup-header">
        <p class="add-lookup-title">{{lookupName}} 
            <img synxTooltip="Asset Type refers to a specific category or model of an asset. It helps you group and identify similar assets easily. (e.g. Enviro 400 double-decker for a bus)"
                src="assets/icons/information-outline.svg" synxTooltipCaret="below">
        </p>
        <a (click)="closeForm()">
            <i class="fas fa-lg fa-times lookup-close"></i>
        </a>
    </div>
    <div class="new-lookup-input custom-field-row">
        <div class="custom-field">
            <label class="custom-field-label" for="new-lookup-value">New {{lookupName}}</label>
            <input id="new-lookup-value" class="custom-input" type="text" autocomplete="off" [(ngModel)]="newValue">
        </div>
        <button type="button" class="custom-button custom-button-flat" (click)="addNew()" >
            Add
        </button>
    </div>
    <p class="lookup-list-title">{{listTitle}} <span class="lookup-results-count">[{{resultsLength}}]</span></p>
    <div *ngIf="showSearchBar" class="custom-field lookup-search">
        <label class="custom-field-label lookup-search-label" for="lookup-search">
            <i class="fas fa-search"></i>
            Search
        </label>
        <input id="lookup-search" class="custom-input" type="text" autocomplete="off"
            (keydown.enter)="$event.preventDefault()" (keyup)="searchTermChanged($event)"/>
    </div>
    <ul class="lookup-list">
        <li *ngFor="let lookup of data;" class="lookup-item" (click)="selectItem(lookup)">
            <span class="lookup-item-name">{{lookup.name}}</span>
            <button type="button" class="custom-icon-button" (click)="delete($event, lookup)">
                <i class="fas fa-lg fa-times"></i>
            </button>
        </li>
    </ul>
</div>